export const WEB_LINKS = {
    DOWNLOAD_APP_FALLBACK: 'https://bloomholding.com',
    INSTAGRAM: 'https://www.instagram.com/bloomholding',
    TWITTER: 'https://x.com/BloomHolding/',
    FACEBOOK: 'https://www.facebook.com/BloomHolding/',
    LINKEDIN: 'https://www.linkedin.com/company/bloom-properties',
    TIKTOK: 'https://www.tiktok.com/@bloom.holding',
    YOUTUBE: 'https://www.youtube.com/@BloomHoldings',
} as const;


